import i18n from '~/components/i18n';
import { milkPaymentStatus } from '../Invoice/constants';

export const getSteps = () => [
  {
    title: i18n.t('Start process'),
    titleAfterFinished: i18n.t('Process started successfully'),
    description: i18n.t('Please click \'Generate your milk bill\' button'),
    statusValue: milkPaymentStatus.defaultStatus
  },
  {
    title: i18n.t('Create milk payment statements'),
    titleAfterFinished: i18n.t('MGA created successfully'),
    description: i18n.t('Please be patient while milk cash statements are generated for farmers. This process step may take a few minutes'),
    statusValue: milkPaymentStatus.generatingStatus
  },
  {
    title: i18n.t('Verify MGA'),
    titleAfterFinished: i18n.t('MGA successfully verified'),
    description: i18n.t('Please check the individual milk payment statements including the printout before continuing to create the SEPA XML.'),
    statusValue: milkPaymentStatus.verificationStatus
  },
  {
    title: i18n.t('SEPA XML'),
    titleAfterFinished: i18n.t('SEPA XML generated successfully'),
    description: i18n.t('Check and import the SEPA XML into your banking program and then close the billing month.'),
    statusValue: milkPaymentStatus.preclosingStatus
  },
  {
    title: i18n.t('Close billing month'),
    titleAfterFinished: i18n.t('MGA successfully completed'),
    description: i18n.t(''),
    statusValue: milkPaymentStatus.closedStatus
  }
]

export const actions = [
  {
    popupMessage: i18n.t('Preview'),
    type: 'icon',
    name: 'eye',
    size: 'large',
    actionType: 'preview'
  },
  {
    popupMessage: i18n.t('Recalculate and create MGA'),
    type: 'icon',
    name: 'refresh',
    size: 'large',
    actionType: 'recalculate'
  }
]

export const getTableColumnHeaders = () => [
  {
    name: i18n.t('Billing month'),
    key: 'billingMonth',
    type: 'date',
    format: 'MMM YYYY'
  },
  {
    name: i18n.t('Supp. no.'),
    key: 'supplierNo',
    sorted: 'asc'
  },
  {
    name: i18n.t('Supplier'),
    key: 'companyName'
  },
  {
    name: i18n.t('Total amount (in kg)'),
    key: 'amountInKg',
    type: 'no-unit-number',
    decimalScale: 0
  },
  {
    name: i18n.t('Milk price net (in €)'),
    key: 'netTotal',
    type: 'no-unit-number'
  },
  {
    name: i18n.t('Price (in € Ct/kg)'),
    key: 'basePrice',
    type: 'no-unit-number'
  },
  {
    name: i18n.t('Verified?'),
    key: 'hasErrors',
    type: 'invoice-errors'
  },
  {
    name: i18n.t('Payout amount (in €)'),
    key: 'total',
    type: 'no-unit-number'
  },
  {
    name: i18n.t('Actions')
  }
]